import React from 'react'
import { Field, FormikProps } from 'formik'
import { IFile } from '../../types/file'
import {
  formatFileName,
  splitFileNameExt,
  UpdateOptions,
  calculateInitialValuesForUploadModalForm,
} from '../../services/file'
import { CustomSelectField } from '../CustomSelectField'
import { CustomCheckboxField } from '../CustomCheckboxField'
import { Caption } from '../StyledText'

export interface IUpdateArchiveModalFormFragment {
  file: IFile
  extensionsMatch: boolean
  formikProps: FormikProps<
    ReturnType<typeof calculateInitialValuesForUploadModalForm>
  >
}

export const UpdateArchiveModalFormFragment = ({
  file,
  extensionsMatch,
  formikProps,
}: IUpdateArchiveModalFormFragment) =>
  extensionsMatch ? (
    <div>
      <Field
        name={'archiveUpdateOptions'}
        label={`Overwrite package ${formatFileName(
          file.existingEdition?.file.fileName as string,
          40
        )}, select the folders that have been modified:`}
        component={CustomSelectField}
      >
        {[
          {
            value: UpdateOptions.ALL_FOLDERS,
            label: 'All folders',
          },
          {
            value: UpdateOptions.NEW_FOLDERS,
            label: 'Only new folder(s)',
          },
          {
            value: UpdateOptions.SELECTED_FOLDERS,
            label: 'Selected folder(s)',
          },
        ]}
      </Field>
      {formikProps.values.archiveUpdateOptions ===
      UpdateOptions.SELECTED_FOLDERS ? (
        <>
          {formikProps.values.archiveFilesToUpdate.map((item, i) => (
            <div key={item.id}>
              <Field
                name={`archiveFilesToUpdate.${i}.value`}
                label={item.label}
                component={CustomCheckboxField}
                validate={() =>
                  !formikProps.values.archiveFilesToUpdate.some(
                    ({ value }) => value
                  )
                }
              />
            </div>
          ))}
          {!!formikProps.errors.archiveFilesToUpdate && (
            <Caption id="update-selected-folders-error" color="error">
              Select the folders that have changed
            </Caption>
          )}
        </>
      ) : null}
    </div>
  ) : (
    <Caption id="update-single-file-message" color="error">
      {`The uploaded file type does not match the type of the stored file (.${
        splitFileNameExt(file.existingEdition?.file.fileName as string)
          .extension
      })`}
    </Caption>
  )
